import types from "../actions/actionTypes";
import initialState from "./initialState";


export default function organisationsReducer(state = initialState.organisationsList, action) {

     const merge = (current, updates) => {       
        let result = current.map(organisation => {
            const updateOrNothing = updates.find(pi => pi.id === organisation.id);
            if (updateOrNothing !== undefined) {
                return updateOrNothing;
            }
            return organisation;
         });   
        const existingIds = result.map(organisation => organisation.id);
        const newOrganisations = updates.filter(organisation => !existingIds.includes(organisation.id));
        return [...result, ...newOrganisations];   
    }

      const deleteOrganisation = (current, id) => {
        return current.filter(organisation => organisation.id !== id);
    } 

    switch (action.type) {
        case types.LOAD_ORGANISATIONS_SUCCESS:
            return action.organisationsList;
        case types.LOAD_ORGANISATIONS_UPDATE_SUCCESS:
            return merge(state, action.organisationsList);
         case types.DELETED_ORGANISATION:    
            return deleteOrganisation(state, action.id);
        case types.DELETED_ORGANISATION_INCOMING:
            return deleteOrganisation(state, action.payload); 
        default:
            return state;
    }
}

